export interface StateColor {
  stateName: string;
  colors: {
    primary: string;
    secondary: string;
  };
}

export const COLORS: StateColor[] = [
  {
    stateName: "benelux",
    colors: {
      primary: "#EF2A2D",
      secondary: "#20478B"
    }
  },
  {
    stateName: "france",
    colors: {
      primary: "#FF4A55",
      secondary: "#41489B"
    }
  },
  {
    stateName: "germany",
    colors: {
      primary: "#FF4A55",
      secondary: "#FFE05A"
    }
  },
  {
    stateName: "uk",
    colors: {
      primary: "#FF4A55",
      secondary: "#41489B"
    }
  },
  {
    stateName: "uk",
    colors: {
      primary: "#FF4A55",
      secondary: "#41489B"
    }
  },
  {
    stateName: "switzerland",
    colors: {
      primary: "#FF4A55",
      secondary: "#FF4A55"
    }
  },
  {
    stateName: "scandinavia",
    colors: {
      primary: "#ef2a2d",
      secondary: "#006AA7"
    }
  },
  {
    stateName: "spain",
    colors: {
      primary: "#DD152C",
      secondary: "#FFD033"
    }
  },
  {
    stateName: "uae",
    colors: {
      primary: "#FF4A55",
      secondary: "#73AE01"
    }
  },
  {
    stateName: "uganda",
    colors: {
      primary: "#FFE05A",
      secondary: "#FF4A55"
    }
  },
  {
    stateName: "southafrica",
    colors: {
      primary: "#73AE01",
      secondary: "#41489B"
    }
  },
  {
    stateName: "australia",
    colors: {
      primary: "#eb3323",
      secondary: "#E70022"
    }
  },
  {
    stateName: "china-and-hong-kong",
    colors: {
      primary: "#E02600",
      secondary: "#CDB400"
    }
  },
  {
    stateName: "usa",
    colors: {
      primary: "#3C3970",
      secondary: "#B42030"
    }
  },

  {
    stateName: "brazil",
    colors: {
      primary: "#0F8E00",
      secondary: "#fbe171"
    }
  },
  {
    stateName: "singapore",
    colors: {
      primary: "#F02532",
      secondary: "#8B171E"
    }
  }
];
